var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('file-download-link',{attrs:{"api-url":'/files/' + _vm.file.id,"filename":_vm.file.original_filename,"download":_vm.download}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }